import { useTranslations } from 'next-intl'
import { z } from 'zod'

export const ACCOUNT_FORM_FIELDS = ['bankName', 'bankAccount', 'accountHolder']

export const ZAccountForm = z.object({
  bankName: z.string().trim(),
  bankAccount: z.string().trim(),
  accountHolder: z.string(),
})

export type TAccountForm = z.infer<typeof ZAccountForm>

export const createAccountValidation =
  (t: ReturnType<typeof useTranslations<'deposit_information'>>) =>
  (data: TAccountForm, ctx: z.RefinementCtx) => {
    if (data.bankName.length < 1) {
      ctx.addIssue({
        path: ['bankName'],
        code: z.ZodIssueCode.custom,
        message: t('error.bank_required'),
      })
    }
    if (data.bankAccount.length < 1) {
      ctx.addIssue({
        path: ['bankAccount'],
        code: z.ZodIssueCode.custom,
        message: t('error.account_number_required'),
      })
    }
  }

export const accountFormDefaultValues = {
  bankName: '',
  bankAccount: '',
  accountHolder: '',
}
